import ErrorNotFound from '@/pages/ErrorNotFound.vue';
import ErrorUnauthorized from '@/pages/ErrorUnauthorized.vue';
import ErrorInternalServer from '@/pages/ErrorInternalServer.vue';

export default [
    {
        path: '/403',
        name: 'error.403',
        component: ErrorUnauthorized
    },
    {
        path: '/404',
        name: 'error.404',
        component: ErrorNotFound
    },
    {
        path: '/500',
        name: 'error.500',
        component: ErrorInternalServer
    },
    {
        path: '*',
        redirect: {
            name: 'error.404'
        }
    }
];
